import { createContext } from 'react';
import noop from 'utils/noop';

type Credentials = {
  googleApiKey?: string
}

const CredentialsContext = createContext<{
  credentials: Credentials | null,
  setCredentials: (credentials: Credentials) => void,
}>({
  credentials: null,
  setCredentials: noop
})

export default CredentialsContext